import { produce } from "immer";
import {
  DELETE_FILE_SUCCESS,
  GET_FILES_SUCCESS,
  GET_FILES_FAILURE,
  GET_FILES_INITIATE,
  UPDATE_FILE_SUCCESS,
  UPLOAD_FILE_SUCCESS,
  CLEAR_FILES,
  GET_DIRECTORY_CONTENTS_SUCCESS,
  SET_CURRENT_DIRECTORY_SUCCESS,
  SET_FILTERED_CURRENT_DIRECTORY_SUCCESS,
} from "../events/filesEvents";

const initialState = {
  files: [],
  completedFiles: [],
  currentDirectory: null,
  filteredCurrentDirectory: null,
  loading: false,
  isFetched: false,
};

const filesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_FILES_INITIATE: {
      return produce(state, (draft) => {
        draft.loading = true;
        draft.isFetched = false;
      });
    }

    case GET_FILES_SUCCESS: {
      const { files } = action.payload;
      return produce(state, (draft) => {
        draft.files = files;
        if (files) {
          draft.completedFiles = files.filter(
            (file) => file["status"] === "completed"
          );
        }
        draft.loading = false;
        draft.isFetched = true;
      });
    }

    case GET_FILES_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case GET_DIRECTORY_CONTENTS_SUCCESS: {
      const { directory } = action.payload;
      return produce(state, (draft) => {
        // const sortedFiles = getSortedFiles(
        //   directory.files,
        //   sortOptions[1].value
        // );
        // const sortedDirectories = getSortedFiles(
        //   directory.directories,
        //   sortOptions[0].value
        // );

        // const sortedDirectory = {
        //   ...directory,
        //   files: sortedFiles,
        //   directories: sortedDirectories,
        // };
        const files = directory.files || [];
        const directories = directory.directories || [];
        draft.currentDirectory = {
          ...directory,
          files: files,
          directories: directories,
        };
        draft.filteredCurrentDirectory = {
          ...directory,
          files: files,
          directories: directories,
        };
      });
    }

    case SET_CURRENT_DIRECTORY_SUCCESS: {
      const { directory } = action.payload;
      return produce(state, (draft) => {
        draft.currentDirectory = directory;
      });
    }

    case SET_FILTERED_CURRENT_DIRECTORY_SUCCESS: {
      const { directory } = action.payload;
      return produce(state, (draft) => {
        draft.filteredCurrentDirectory = directory;
      });
    }

    case UPDATE_FILE_SUCCESS: {
      const { file } = action.payload;
      return produce(state, (draft) => {
        const files = draft.files.map((f) => {
          if (f["id"] === file["id"]) {
            return { ...f, name: file["name"] };
          }
          return f;
        });
        draft.files = files;
        if (files) {
          draft.completedFiles = files.filter(
            (file) => file["status"] === "completed"
          );
        }
      });
    }

    case DELETE_FILE_SUCCESS: {
      const { fileId } = action.payload;
      return produce(state, (draft) => {
        const files = draft.files.filter((file) => fileId !== file["id"]);
        draft.files = files;
        if (files) {
          draft.completedFiles = files.filter(
            (file) => file["status"] === "completed"
          );
        }
      });
    }

    case UPLOAD_FILE_SUCCESS: {
      const { file } = action.payload;
      return produce(state, (draft) => {
        draft.files = [file, ...draft.files];
        if (draft.files) {
          draft.completedFiles = draft.files.filter(
            (file) => file["status"] === "completed"
          );
        }
        if (draft.currentDirectory) {
          const currentFiles = draft.currentDirectory.files || [];
          const updatedFiles = [file, ...currentFiles];
          if (updatedFiles.length > 10) {
            updatedFiles.pop();
          }
          draft.currentDirectory = {
            ...draft.currentDirectory,
            files: updatedFiles,
            pagination: {
              ...draft.currentDirectory.pagination,
              total_files: draft.currentDirectory.pagination.total_files + 1,
            },
          };
        }
        if (draft.filteredCurrentDirectory) {
          const currentFiles = draft.filteredCurrentDirectory.files || [];
          const updatedFiles = [file, ...currentFiles];
          if (updatedFiles.length > 10) {
            updatedFiles.pop();
          }
          draft.filteredCurrentDirectory = {
            ...draft.filteredCurrentDirectory,
            files: updatedFiles,
            pagination: {
              ...draft.filteredCurrentDirectory.pagination,
              total_files: draft.filteredCurrentDirectory.pagination.total_files + 1,
            },
          };
        }
      });
    }

    case CLEAR_FILES: {
      return produce(state, (draft) => {
        draft.files = [];
        draft.completedFiles = [];
        draft.currentDirectory = null;
        draft.filteredCurrentDirectory = null;
      });
    }

    default: {
      return state;
    }
  }
};

export default filesReducer;
